export default __webpack_public_path__ + "static/media/image-1.3835edb5.jpg";